// Page.js
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const formatRouteName = (route) => {
  if (!route || route.length === 0) return "";
  // Capitalize first letter, keep rest as-is to preserve camel case
  return route.charAt(0).toUpperCase() + route.slice(1);
};

const Page = ({ defaultTitle, children }) => {
  const location = useLocation();

  useEffect(() => {
    // Get pageTitle from navigation state if passed (e.g. clicked card)
    const stateTitle = location.state?.pageTitle;
    if (stateTitle) {
      // Format stateTitle with first letter uppercase
      const formattedStateTitle = stateTitle.charAt(0).toUpperCase() + stateTitle.slice(1);
      document.title = `${formattedStateTitle} - Washington Gas eService Center`;
    } else if (defaultTitle) {
      // defaultTitle assumed to be route path like "/home"
      const routeSegment = defaultTitle.startsWith("/")
        ? defaultTitle.slice(1)
        : defaultTitle;

      const formattedRoute = formatRouteName(routeSegment);
      document.title = ` ${formattedRoute} -Washington Gas eService Center`;
    }
  }, [location, defaultTitle]);

  return <>{children}</>;
};

export default Page;
